import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex items-center justify-end flex-1 relative w-full p-3 md:p-2 2xl:p-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("picture", null, [
  /*#__PURE__*/_createElementVNode("source", {
    srcset: "/images/auth_hero_image_new_1920.webp",
    type: "image/webp",
    media: "(min-width:1025px)"
  }),
  /*#__PURE__*/_createElementVNode("source", {
    srcset: "/images/auth_hero_image_new_ipad.webp",
    type: "image/webp",
    media: "(min-width:768px) and (max-width:1024px)"
  }),
  /*#__PURE__*/_createElementVNode("source", {
    srcset: "/images/auth_hero_image_new_mobile.webp",
    type: "image/webp",
    media: "(min-width:320px)"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "absolute inset-0 h-full w-full object-cover object-center",
    src: "/images/auth_hero_image_new.jpg",
    alt: "William Ryan Homes",
    width: "1920",
    height: "1100"
  })
], -1)
const _hoisted_3 = { class: "bg-white relative shadow-modal mx-auto w-full max-w-xs md:w-lg lg:w-xl md:mx-0 md:right-8 md:max-w-full lg:right-16 rounded-lg justify-center p-4 md:p-6 xl:p-12" }
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = { class: "flex items-end mx-auto justify-center md:w-[26rem]" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-4 xl:mt-5 mb-2 md:mt-10 md:mb-5 t-18m md:t-40m text-wrh-blue-dark" }, " Forgot Password? ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "t-12r md:t-14r mb-1" }, "Please enter your email address.", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "t-12r md:t-14r" }, "We will send instructions to help reset your password.", -1)
const _hoisted_9 = { class: "mt-5 md:mt-10" }
const _hoisted_10 = ["onSubmit"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "block t-12r md:t-14r text-wrh-gray-dark"
}, " Email address ", -1)
const _hoisted_12 = { class: "mt-2 relative" }
const _hoisted_13 = {
  key: 0,
  class: "wrh-error"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "lg:pt-4" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "w-full uppercase flex justify-center py-2 px-4 border border-transparent rounded shadow-sm text-sm t-14m text-white bg-wrh-blue-light hover:bg-wrh-blue-600 focus:outline-none transition-colors duration-300 ease-in-out"
  }, " Send Reset Instructions ")
], -1)
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Back to Log In")

import { ref } from 'vue';
// import { getAuth, sendPasswordResetEmail } from 'firebase/auth';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import Footer from '../../components/Footer.vue';
import { checkValidation, resetEmailApiResponse } from './services/service';
import { apiPasswordReset } from '@/api';
import Alert from '@/components/Alert.vue';
import { Response, Routes } from '@/constants';
import Logo from '@/components/icons/Logo.vue';
import { showLoader } from '@/util/funcs';
import MyHomeLogo from '@/components/icons/MyHomeLogo.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const router = useRouter();
const email = ref('');
const persistAuth = ref(false);
const responseApi = ref({});
const emailError = ref('');
const emailErrorStatus = ref(false);
const modalActive = ref('');
let valid = false;

const check = () => {
  const validMessage = checkValidation(email.value);
  emailErrorStatus.value = false;
  emailError.value = '';
  if (validMessage.emailMessage !== '') {
    emailError.value = validMessage.emailMessage;
    emailErrorStatus.value = true;
  } else if (validMessage.emailValidation !== '') {
    emailError.value = validMessage.emailValidation;
    emailErrorStatus.value = true;
  } else {
    valid = true;
  }
};

const showModal = () => {
  const value = resetEmailApiResponse(responseApi.value);
  modalActive.value = value;
};

const submit = async () => {
  showLoader(true);
  check();
  if (valid) {
    responseApi.value = await apiPasswordReset(email.value);
    showModal();
  }
  showLoader(false);
};

const closeAlertBox = () => {
  if (modalActive.value === Response.SENT) {
    modalActive.value = '';
    router.push({ name: Routes.LOGIN });
  }
  modalActive.value = '';
};


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(Logo, { class: "w-[150px] md:w-[263px]" }),
            _createVNode(MyHomeLogo, {
              width: "165",
              height: "51",
              class: "max-w-full ml-4 w-[100px] -mb-1 md:w-[162px]",
              alt: "William Ryan Homes 24-7"
            })
          ]),
          _hoisted_6,
          _hoisted_7,
          _hoisted_8
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("form", {
            action: "#",
            method: "POST",
            class: "space-y-2 md:space-y-4 lg:space-y-6",
            onSubmit: _withModifiers(submit, ["prevent"]),
            novalidate: ""
          }, [
            _createElementVNode("div", null, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _withDirectives(_createElementVNode("input", {
                  id: "email",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (email.value = $event)),
                  name: "email",
                  type: "email",
                  autocomplete: "email",
                  placeholder: "Your Email",
                  class: _normalizeClass(["wrh-input", [emailErrorStatus.value ? 'border-red-600':'']])
                }, null, 2), [
                  [_vModelText, email.value]
                ]),
                (emailError.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(emailError.value), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_router_link, {
                to: { name: _unref(Routes).LOGIN },
                class: "t-12r md:t-14r text-wrh-blue-400 hover:text-wrh-blue-600"
              }, {
                default: _withCtx(() => [
                  _hoisted_16
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ], 40, _hoisted_10)
        ])
      ])
    ]),
    (modalActive.value)
      ? (_openBlock(), _createBlock(Alert, {
          key: 0,
          alertType: modalActive.value,
          onCloseAlert: closeAlertBox
        }, null, 8, ["alertType"]))
      : _createCommentVNode("", true),
    _createVNode(Footer)
  ], 64))
}
}

})